import { render } from "./EmailConsultPanel.vue?vue&type=template&id=2fd21b2c&scoped=true"
import script from "./EmailConsultPanel.vue?vue&type=script&lang=js"
export * from "./EmailConsultPanel.vue?vue&type=script&lang=js"

import "./EmailConsultPanel.vue?vue&type=style&index=0&id=2fd21b2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd21b2c"]])

export default __exports__